import Vue from 'vue'
import App from '../components/step1/App.vue'
import step1 from '../store/step1/step1'
import VueRouter from 'vue-router'
import VTooltip from 'v-tooltip'
import '../filter/common-filter'
import VueHtmlToPaper from 'vue-html-to-paper';



Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(VTooltip)

const options = {
  name: '_blank',
  specs: [
    'scrollbars=yes',
    'titlebar=yes',
    'height=1200',
    'width=1200',
  ],
  styles: [
    process.env.VUE_APP_GOOD_STEP_SITE + '/step1.css'
  ]
}
Vue.use(VueHtmlToPaper, options);


const router = new VueRouter({
  mode: 'history'
})

new Vue({
  router,
  store: step1,
  render: h => h(App),
}).$mount('#step1-app')
